export default __webpack_public_path__ + "static/0f8546cf0747dd350bdf9b08d2dd6cdd.png";